// App-wide default query refetch interval

const DEFAULT_REFETCH_INTERVAL = 300_000;

// Exports
// -------

export default DEFAULT_REFETCH_INTERVAL;
